import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { DEPT_MENUS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/menus/")({
  component: () => <DeptContentList cfg={DEPT_MENUS} />,
});
